import React from 'react';
import { Card, Button, Space, Typography } from 'antd';

const { Text } = Typography;

const UpcomingRenewalsContainer: React.FC = () => {
    const renewals = [
        { id: 1, name: 'Global Tech Renewal', customer: 'Tech Corp', value: 85000000, days: 12 },
        { id: 2, name: 'Innovate Inc Annual', customer: 'Innovate Inc', value: 120000000, days: 28 },
        { id: 3, name: 'Startup Hub Contract', customer: 'Startup Hub', value: 45000000, days: 45 },
    ];

    return (
        <Card
            title="Gia hạn sắp tới"
            extra={<Button type="link">Xem tất cả</Button>}
        >
            <Space direction="vertical" style={{ width: '100%' }} size={12}>
                {renewals.map((item) => (
                    <Card key={item.id} size="small" bordered>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <Text strong>{item.name}</Text>
                                <br />
                                <Text type="secondary">{item.customer}</Text>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <Text strong style={{ color: '#13C2C2' }}>
                                    {item.value.toLocaleString()} ₫
                                </Text>
                                <br />
                                <Text
                                    style={{
                                        color: item.days <= 15 ? '#FF4D4F' : item.days <= 30 ? '#FAAD14' : '#13C2C2',
                                        fontWeight: 500,
                                    }}
                                >
                                    Còn {item.days} ngày
                                </Text>
                            </div>
                        </div>
                    </Card>
                ))}
            </Space>
        </Card>
    );
};

export { UpcomingRenewalsContainer };